import * as React from "react"
import { DisplayProps } from "styled-system"
import { ChildrenProps } from "../../@types/@core"
import { INNER_MAX_WIDTH } from "../../constants"
import { Flex } from "../Flex"
import { SecondaryMenuListStyled, SecondaryMenuItemStyled } from "./styled"

export const SECONDARY_MENU_HEIGHT_S = 8
export const SECONDARY_MENU_HEIGHT_L = 12

export interface SecondaryMenuProps {
	zIndex?: number
	children?: React.ReactNode
}

export interface SecondaryMenuComponent {
	List: React.FC<ChildrenProps>
	Item: React.FC<DisplayProps & React.HTMLAttributes<HTMLLIElement>>
}

const SecondaryMenu: React.FC<SecondaryMenuProps> & SecondaryMenuComponent = (
	props
) => {
	return (
		<Flex
			w={1}
			h={{ _: 8, l: SECONDARY_MENU_HEIGHT_L }}
			px={3}
			backgroundColor="blue11"
			justifyContent="center"
			alignItems="center"
			zIndex={props.zIndex}
		>
			<Flex w={1} h={1} maxw={INNER_MAX_WIDTH}>
				{props.children}
			</Flex>
		</Flex>
	)
}

SecondaryMenu.List = (props) => (
	<Flex as="nav" w={1}>
		<SecondaryMenuListStyled>{props.children}</SecondaryMenuListStyled>
	</Flex>
)

SecondaryMenu.Item = (props) => <SecondaryMenuItemStyled {...props} />

export { SecondaryMenu }
